export const HEIGHT_CONTROL_PANEL_UUID = '33ad7830-9c0e-454a-9a88-0e42a65cafe8';
export const HEIGHT_CONTROL_PANEL_WIDTH = 17;
export const HEIGHT_CONTROL_PANEL_INITIAL_POSITION = 0;
export const SLOT_LINE_MOVE_STEPS = 17; // in centimeters
export const FACTOR_CENTIMETER_MILLIMETER = 10;

export const FAKE_USER_ID_KEY = 'fakeId';
export const FAKE_USER_ID_PREFIX = 'fuid-';
export const ANONYMOUS_USER = 'anonymousUser';

export const DEFAULT_INPUT_DEBOUNCE_DELAY_MS = 500;
